exports = module.exports = require("../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".van-list__error-text,\n.van-list__finished-text,\n.van-list__loading {\n  color: #969799;\n  font-size: 0.186667rem;\n  line-height: 0.666667rem;\n  text-align: center;\n}\n\n.van-list__placeholder {\n  height: 0;\n  pointer-events: none;\n}", "", {"version":3,"sources":["D:/WenZhouBangZhang/BZQD/node_modules/vant/es/list/D:/WenZhouBangZhang/BZQD/node_modules/vant/es/list/index.css"],"names":[],"mappings":"AAAA;;;EAGE,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;CACpB;;AAED;EACE,UAAU;EACV,qBAAqB;CACtB","file":"index.css","sourcesContent":[".van-list__error-text,\n.van-list__finished-text,\n.van-list__loading {\n  color: #969799;\n  font-size: 0.186667rem;\n  line-height: 0.666667rem;\n  text-align: center;\n}\n\n.van-list__placeholder {\n  height: 0;\n  pointer-events: none;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./node_modules/px2rem-loader??ref--5-3!./node_modules/vant/es/list/index.css
// module id = OlHf
// module chunks = 143